module.exports = __webpack_public_path__ + "static/media/patrol(9).a5c64d9d.PNG";